const CUSTOM_PREFIX = "custom_fields.";

/** The other row that feeds the same prompt variable, if any. The server
 *  hoists ``custom_fields.<x>`` to top-level ``<x>``, so a profile with
 *  both is one input the prompt sees, shown as two rows. */
const twinKey = (key: string): string | null => {
  if (key.startsWith(CUSTOM_PREFIX)) return key.slice(CUSTOM_PREFIX.length);
  if (key.includes(".")) return null; // biographic_info.* and other nested rows
  return `${CUSTOM_PREFIX}${key}`;
};

/** Toggle a row's checkbox, moving its twin with it — otherwise unchecking
 *  one copy still sends the other's value. */
export const toggleMockKey = (disabled: Set<string>, key: string): Set<string> => {
  const next = new Set(disabled);
  const keys = [key, twinKey(key)].filter((k): k is string => k !== null);
  const turningOff = !disabled.has(key);
  for (const k of keys) {
    if (turningOff) next.add(k);
    else next.delete(k);
  }
  return next;
};
